<template>
  <div class="">
    <div class="tw-flex tw-gap-2 tw-mb-3 tw-justify-start">
      <base-button v-if="shouldShowDeleteButton" :loading="isDeleting" type="primary" color="red" class="tw-justify-self-end tw-mb-3" @click="bulkDelete"
        >Delete {{ selectedItems.length }} Activities</base-button
      >
      <base-button
        v-if="selectedItems.length > 0 && managementUsers.includes(userEmail) && ['unassigned', 'assigned'].includes(category)"
        type="primary"
        class="tw-justify-self-end tw-mb-3"
        @click="bulkAssign"
        >Batch {{ category == "unassigned" ? "Assign" : "Reassign" }} {{ selectedItems.length }} Activities</base-button
      >
      <base-button
        v-if="selectedItems.length > 0 && managementUsers.includes(userEmail) && category == 'assigned'"
        type="primary"
        class="tw-justify-self-end tw-mb-3"
        @click="bulkUnassign"
        >Batch Unassign {{ selectedItems.length }} Activities</base-button
      >
    </div>

    <base-table ref="todoItems" :loading="isLoading" :fields="fields" :items="items" :overflowVisible="false" @checked="selectAll">
      <template v-if="isLocationFiltered === false" #actionBox="{ item: todoItem }">
        <template v-if="todoItem.isDeleted === false">
          <base-checkbox :value="todoItem.todoItemId" v-model="selectedItems" :disabled="todoItem.isDeleted == true" />
        </template>
      </template>
      <template #dueDate="{ item: todoItem }">
        <div class="tw-flex tw-items-center tw-text-sm tw-whitespace-nowrap">
          <div v-if="isLocationFiltered === true" :class="'tw-text-' + dueDateColor(todoItem.dueDate) + '-500'">{{ dueDateFormatter(todoItem.dueDate) }}</div>
          <base-button v-else type="text" :color="dueDateColor(todoItem.dueDate)" @click="editDueDate(todoItem)" :disabled="todoItem.isDeleted == true">
            {{ dueDateFormatter(todoItem.dueDate) }}
          </base-button>
        </div>
        <div v-if="todoItem.status == 'completed'" class="tw-text-xs tw-text-gray-500 ">
          <div class="tw-flex tw-items-center tw-text-xs tw-text-gray-500 tw-whitespace-nowrap">
            <span>Completed By:</span>
          </div>
          <div class="tw-flex tw-items-center tw-text-xs tw-text-gray-500 tw-whitespace-nowrap">
            <span>{{ todoItem.insertBy }}</span>
          </div>
          <div class="tw-flex tw-items-center tw-text-xs tw-text-gray-500 tw-whitespace-nowrap">
            <span> ({{ todoItem.completedDate }}) </span>
          </div>
        </div>
      </template>
      <template #todoItem="{ item: todoItem }">
        <div class="tw-flex">
          <div>
            <div class="tw-flex tw-flex-col tw-items-start">
              <div class="tw-flex">
                <div class="tw-flex tw-font-normal tw-text-gray-700 tw-text-base tw-whitespace-nowrap">{{ todoItem.todoItemTypeLabel }}</div>
                <base-badge v-if="todoItem.isDeleted == true && category != 'deleted'" class="tw-ml-2" size="sm" color="red">Archived</base-badge>
                <base-badge v-if="category === 'deleted'" class="tw-ml-2" size="sm" color="gray">{{ todoItem.status }}</base-badge>
              </div>
              <div class="tw-flex tw-font-normal tw-text-xs tw-whitespace-nowrap">
                <base-button type="text" size="md" @click="gotoMember(todoItem.userId)">{{ todoItem.userName }}</base-button>
              </div>
              <div v-if="todoItem.businessLocationName != null" class="tw-flex tw-text-xs tw-text-gray-500 tw-whitespace-nowrap">{{ todoItem.businessLocationName }}</div>
              <base-button v-else type="text" size="xs" color="red" @click="assignLocation(todoItem)">No Location Associated</base-button>
              <div v-if="todoItem.programName != null" class="tw-flex tw-text-xs tw-text-gray-500 tw-whitespace-nowrap">
                {{ todoItem.programName }}
              </div>
              <div v-if="todoItem.userBusinessPlanName != null" class="tw-flex tw-text-xs tw-text-gray-500 tw-whitespace-nowrap">{{ todoItem.userBusinessPlanName }}</div>
              <div v-if="todoItem.isDeleted == true" class="tw-text-xs tw-text-gray-500 ">
                Deleted By: <span class="tw-text-red-500 "> {{ todoItem.insertBy }}({{ formatEventDate(todoItem.insertDate) }})</span>
              </div>
              <div v-if="todoItem.orderErrorMessage" class="tw-text-xs tw-text-gray-500 ">
                <span class="tw-text-red-500 ">Error occured while submitting order</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #assigned="{ item: todoItem }">
        <template v-if="todoItem.todoItemIsAssignable || todoItem.assignedToUserId || managementUsers.includes(userEmail)">
          <assigned-user-button :todoItem="todoItem" :businessUsers="businessUsers" @assign="assign" :disabled="todoItem.isDeleted == true || todoItem.status === 'inprogress'" />
        </template>
        <div class="tw-text-xs tw-text-gray-500 tw-whitespace-nowrap">{{ customDateFormatter(todoItem.assignedDate) }}</div>

        <base-button v-if="todoItem.status == 'assigned' && todoItem.assignedToUserId && !isLocationFiltered" type="text" size="xs" color="red" @click="unAssign(todoItem)"
          >Unassign</base-button
        >
      </template>
      <template #contact="{ item: todoItem }">
        <div class="tw-flex-col tw-items-start">
          <base-button v-if="todoItem.userPhoneNumber" type="flat" size="xs" @click="call(todoItem.user.PhoneNumber)">
            <template v-slot:icon>
              <phone-icon />
            </template>
            <base-phone-number-field class="tw-hidden lg:tw-block" :value="todoItem.userPhoneNumber" />
          </base-button>
          <base-button v-if="todoItem.userEmailAddress" type="flat" size="xs" @click="email(todoItem.userEmailAddress)">
            <template v-slot:icon>
              <mail-icon />
            </template>
            <span class="tw-hidden lg:tw-block">{{ todoItem.userEmailAddress }}</span>
          </base-button>
        </div>
      </template>

      <template #actions="{ item: todoItem }">
        <div class="tw-flex tw-justify-start tw-space-x-2">
          <base-button type="flat" size="sm" @click="history(todoItem.todoItemId, todoItem.isDeleted, todoItem.businessPrescriptionId)">
            <template v-slot:icon>
              <list-icon />
            </template>
            <span class="tw-whitespace-nowrap">{{
              todoItem.todoItemTypeLabel === "Prescriber Clarification" && isLocationFiltered && todoItem.status !== "completed" ? "Action Needed" : "Details"
            }}</span>
            <base-badge v-show="todoItem.numComments > 0" class="tw-absolute tw--right-2 tw--top-0.5" color="primary" size="xs">{{ todoItem.numComments }}</base-badge>
          </base-button>
          <base-button v-if="!isLocationFiltered" type="flat" size="sm" @click="edit(todoItem)">
            <template v-slot:icon>
              <edit-icon />
            </template>
            Edit
          </base-button>
          <base-button v-if="showReplyAction(todoItem)" type="flat" size="sm" @click="comment(todoItem.todoItemId, todoItem.todoItemTypeConstant)">
            <template v-slot:icon>
              <comment-icon />
            </template>
            Reply
          </base-button>
          <base-button v-if="showCommentAction(todoItem)" type="flat" size="sm" @click="comment(todoItem.todoItemId, todoItem.todoItemTypeConstant)">
            <template v-slot:icon>
              <edit-icon />
            </template>
            Comment
          </base-button>
          <base-button v-if="showCompleteAction(todoItem)" type="flat" size="sm" @click="complete(todoItem.todoItemId)">
            <template v-slot:icon>
              <check-icon />
            </template>
            Complete
          </base-button>
          <base-button v-if="showPlaceOrderAction(todoItem)" type="flat" size="sm" @click="placeOrder(todoItem.todoItemId)">
            <template v-slot:icon>
              <shopping-bag-icon class="tw-h-4 tw-w-4" />
            </template>
            Submit to Pharmacy
          </base-button>
          <base-button v-if="todoItem.status == 'inprogress' && todoItem.orderErrorMessage" type="flat" size="sm" @click="updateOrder(todoItem.todoItemId)" :disabled="isLoading">
            <template v-slot:icon>
              <shopping-bag-icon class="tw-h-4 tw-w-4" />
            </template>
            Re-Submit to Pharmacy
          </base-button>
          <base-button v-if="showDeleteAction(todoItem.isDeleted)" type="flat" size="sm" @click="del(todoItem.todoItemId)">
            <template v-slot:icon>
              <trash-icon />
            </template>
            Delete
          </base-button>
          <base-button v-if="showRefillAuthApproveAction(todoItem)" type="flat" size="sm" @click="approveChanges(todoItem)">
            <template v-slot:icon>
              <check-icon />
            </template>
            Approve
          </base-button>
          <base-button v-if="showRefillAuthDenyAction(todoItem)" type="flat" color="red" size="sm" @click="deny(todoItem.todoItemId)">
            <template v-slot:icon>
              <x-icon />
            </template>
            Deny
          </base-button>
        </div>
      </template>
      <template #empty-state>
        <div class="tw-flex tw-justify-center tw-py-5">
          No Results
        </div>
      </template>
      <template #loading-row>
        <td v-if="isLocationFiltered === false" class="tw-py-3 tw-px-4"><base-skeleton-loader class="tw-h-4 tw-w-4" /></td>
        <td class="tw-py-3 tw-px-4"><base-skeleton-loader class="tw-h-6 tw-w-12" /></td>
        <td class="tw-py-3 tw-px-4"><base-skeleton-loader class="tw-h-6 tw-w-12" /></td>
        <td class="tw-py-3 tw-px-4"><base-skeleton-loader class="tw-h-6 tw-w-24" /></td>
        <td class="tw-py-3 tw-pl-4 tw-pr-8"><base-skeleton-loader class="tw-h-4 tw-w-40" /><base-skeleton-loader class="tw-h-2 tw-w-20 tw-mt-2" /></td>
        <td class="tw-py-3 tw-px-4">
          <div class="tw-flex"><base-skeleton-loader class="tw-h-3 tw-w-3 tw-mr-1" /><base-skeleton-loader class="tw-h-3 tw-w-20" /></div>
          <div class="tw-flex tw-mt-2"><base-skeleton-loader class="tw-h-3 tw-w-3 tw-mr-1" /><base-skeleton-loader class="tw-h-3 tw-w-24" /></div>
        </td>
        <td class="tw-py-3 tw-px-4">
          <div class="tw-flex tw-space-x-2 tw-justify-center">
            <base-skeleton-loader class="tw-h-8 tw-w-20" v-for="key in 4" :key="`action-loader-cell-${key}`" />
          </div>
        </td>
      </template>
    </base-table>
    <base-pagination v-if="page.total > page.take" v-model="page" class="tw-mt-2" />
    <approve-rx-auth-with-changes ref="approveChangesSlideover" :businessId="businessId" :rxItems="rxItems" @save="loadPage" />
    <clarification ref="clarificationSlideover" :businessId="businessId" @save="loadPage" />
    <edit-due-date ref="editDueDateSlideover" :businessId="businessId" @save="modifyLocalDueDate" />
    <batch-assign-todo-items :selected-items="selectedItems" :businessId="businessId" ref="batchAssignModal" @close="closeBatchAssign" />
    <EditTodoItem ref="editTodoModal" :businessId="businessId" />
  </div>
</template>

<script>
import moment from "moment";
import { PhoneIcon, MailIcon, CheckIcon, EditIcon, TrashIcon, ListIcon, CommentIcon, XIcon, ShoppingBagIcon } from "@/assets/svgs";
import { mapGetters } from "vuex";
import AssignedUserButton from "@/views/business/todo/components/AssignedUserButton";
import ApproveRxAuthWithChanges from "@/views/business/todo/components/ApproveRxAuthWithChanges";
import Clarification from "@/views/business/todo/components/Clarification";
import EditDueDate from "@/views/business/todo/components/EditDueDate";
import BatchAssignTodoItems from "@/views/business/todo/components/BatchAssignTodoItems";
import EditTodoItem from "@/views/business/todo/components/EditTodoItem";

import { debounce } from "debounce";

const TAKE_KEY = "predictile_todo_items_take";

export default {
  name: "ItemsList",
  props: {
    businessId: String,
    category: String,
    showRows: { type: Number, default: 10 },
    query: String,
    filters: Object,
    targetEntityId: String,
  },
  components: {
    PhoneIcon,
    MailIcon,
    CheckIcon,
    EditIcon,
    TrashIcon,
    AssignedUserButton,
    ListIcon,
    CommentIcon,
    XIcon,
    ApproveRxAuthWithChanges,
    Clarification,
    EditDueDate,
    BatchAssignTodoItems,
    ShoppingBagIcon,
    EditTodoItem,
  },
  data() {
    return {
      isLoading: true,
      isDeleting: false,
      page: {
        take: localStorage.getItem(TAKE_KEY) ? +localStorage.getItem(TAKE_KEY) : 50,
        skip: 0,
        total: 0,
      },
      businessUsers: [],
      items: [],
      showBatchAssign: false,
      selectedItems: [],
      rxItems: [],
      managementUsers: [
        "ronson@rx-harmony.com",
        "lanie@rx-harmony.com",
        "monica@rx-harmony.com",
        "seth@rx-harmony.com",
        "brittany@rx-harmony.com",
        "durgesh@programodo.com",
        "durgesh@dwebpixel.com",
        "snguyen@thejoigroup.com",
        "aabid.shah@dwebpixel.com",
        "ida@rx-harmony.com",
      ],
      currentTimezone: "", // Add a data property to store the timezone
    };
  },
  computed: {
    fields() {
      let fields = [];

      if (this.isLocationFiltered === false && this.category != "deleted") fields.push({ title: "", key: "actionBox", thClass: "tw-w-0 tw-text-left", isCheckbox: true });

      fields.push(
        { title: "Due Date", key: "dueDate", thClass: "tw-w-0 tw-text-left tw-whitespace-nowrap" },
        { title: "Assigned to", key: "assigned", thClass: "tw-w-0 tw-text-left tw-whitespace-nowrap" },
        { title: "Activity", key: "todoItem", thClass: "tw-w-0 tw-text-left" },
        { title: "Contact", key: "contact", thClass: "tw-w-0 tw-text-left" },
        { title: "Actions", key: "actions", thClass: "tw-w-0 tw-text-center" },
      );
      return fields;
    },
    ...mapGetters("cognito", { userId: "id", userName: "name", userEmail: "email" }),
    ...mapGetters("role", { isLocationFiltered: "isLocationFiltered" }),
    url() {
      if (this.category === "assigned") return `/businesses/${this.businessId}/todo/assigned`;
      else if (this.category === "unassigned") return `/businesses/${this.businessId}/todo/unassigned`;
      else if (this.category === "completed") return `/businesses/${this.businessId}/todo/completed`;
      else if (this.category === "assigned-self") return `/businesses/${this.businessId}/todo/assigned-self`;
      else if (this.category === "deleted") return `/businesses/${this.businessId}/todo/deleted`;
      else return `/businesses/${this.businessId}/todo/open`;
    },
    shouldShowDeleteButton() {
      const hiddenSuffixes = ["/unassigned", "/assigned", "/completed", "/deleted"];
      const currentPath = this.$route.path;

      const isExactBusinessTodo = currentPath.endsWith("/business-todo") && !currentPath.endsWith("/business-todo/");
      const isHiddenSubPath = currentPath.includes("/business-todo/") && hiddenSuffixes.some((suffix) => currentPath.endsWith("/business-todo" + suffix));

      return this.selectedItems.length > 0 && this.isLocationFiltered === false && isExactBusinessTodo && !isHiddenSubPath;
    },
  },
  watch: {
    page(newValue) {
      localStorage.setItem(TAKE_KEY, newValue.take);
      this.loadPage();
    },
    query() {
      this.page.skip = 0;
      this.debouncedLoadPage();
    },
    filters: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.page.skip = 0;
        this.loadPage();
      }
    },
  },
  created() {
    this.detectTimezone(); // Call the timezone detection function
    this.loadPage();
    this.loadBusinessUsers();
    this.getRxItems();
    this.debouncedLoadPage = debounce(this.loadPage, 500);
    this.EventBus.$on("selectAllTodo", this.selectAll);
  },
  mounted() {
    this.EventBus.$on("activitiesUpdated", this.loadPage);
  },
  methods: {
    detectTimezone() {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.currentTimezone = timeZone; // Store the detected timezone
    },
    refresh() {
      this.page.skip = 0;
      this.loadPage();
    },
    next() {
      this.page.skip += this.page.take;
    },
    previous() {
      this.page.skip -= this.page.take;
    },
    showReplyAction(todoItem) {
      return todoItem.todoItemTypeConstant === "ONLINE_SUPPORT_QUESTION" && todoItem.status !== "completed" && todoItem.status !== "inprogress" && !todoItem.isDeleted;
    },
    showCommentAction(todoItem) {
      return (
        todoItem.status !== "completed" &&
        todoItem.status !== "inprogress" &&
        !todoItem.isDeleted &&
        todoItem.todoItemTypeConstant !== "ONLINE_SUPPORT_QUESTION" &&
        todoItem.todoItemTypeConstant !== "RX_AUTHORIZATION" &&
        this.isLocationFiltered === false
      );
    },
    showCompleteAction(todoItem) {
      return (
        todoItem.status !== "completed" &&
        !todoItem.isDeleted &&
        ((todoItem.todoItemTypeConstant !== "RX_AUTHORIZATION" && todoItem.todoItemTypeConstant !== "PRESCRIBER_CLARIFICATION") || todoItem.status == "inprogress") &&
        !this.isLocationFiltered
      );
    },
    showPlaceOrderAction(todoItem) {
      return (
        todoItem.todoItemTypeLabel &&
        todoItem.todoItemTypeLabel.toLowerCase().includes("submit") &&
        !todoItem.isDeleted &&
        todoItem.programName &&
        todoItem.status !== "completed" &&
        todoItem.status !== "inprogress" &&
        !this.isLocationFiltered
      );
    },
    showDeleteAction(isDeleted) {
      return this.isLocationFiltered === false && isDeleted == false;
    },
    showRefillAuthApproveAction(todoItem) {
      return todoItem.status !== "completed" && todoItem.status !== "inprogress" && this.isLocationFiltered === true && todoItem.todoItemTypeConstant === "RX_AUTHORIZATION";
    },
    showRefillAuthDenyAction(todoItem) {
      return todoItem.status !== "completed" && todoItem.status !== "inprogress" && this.isLocationFiltered === true && todoItem.todoItemTypeConstant === "RX_AUTHORIZATION";
    },
    showClarifyAction(todoItem) {
      return (
        todoItem.status !== "completed" && todoItem.status !== "inprogress" && this.isLocationFiltered === true && todoItem.todoItemTypeConstant === "PRESCRIBER_CLARIFICATION"
      );
    },
    getUser(userId) {
      if (userId && this.businessUsers.length > 0) return this.businessUsers.find((u) => u.userId === userId).initials;
      else return "";
    },
    call(phoneNumber) {
      window.open("tel:" + phoneNumber);
    },
    email(emailAddress) {
      window.open("mailto:" + emailAddress);
    },
    del(item) {
      this.$emit("del", item);
    },
    comment(item, constant) {
      this.$emit("comment", { todoItemId: item, constant: constant });
    },
    history(todoItemId, isDeleted, businessPrescriptionId) {
      this.$emit("history", { todoItemId: todoItemId, isDeleted: isDeleted, businessPrescriptionId: businessPrescriptionId });
    },
    assign(item) {
      this.$emit("assign", item);
    },
    assignLocation(item) {
      this.$emit("assign-location", item);
    },
    approveChanges(item) {
      this.$refs.approveChangesSlideover.show(item.todoItemId, item.userId, item.businessPrescriptionId);
    },
    clarify(item) {
      this.$refs.clarificationSlideover.show(item.todoItemId, item.userId, item.businessPrescriptionId);
    },
    deny(item) {
      this.$emit("deny", item);
    },
    editDueDate(item) {
      this.$refs.editDueDateSlideover.show(item.todoItemId, item.dueDate);
    },
    formatEventDate(date) {
      return moment
        .utc(date)
        .local()
        .format("M/D/YY h:mm A");
    },
    loadPage() {
      this.isLoading = true;
      let url = `/businesses/${this.businessId}/todo/search`;
      url += `?skip=${this.page.skip}&take=${this.page.take}&query=${encodeURIComponent(this.query || "")}`;

      if (this.targetEntityId != null) url += `&targetUserId=${this.targetEntityId}`;

      let filters = {
        locationsFilter: [],
        typesFilter: [],
        assignedToFilter: [],
        startDate: null,
        endDate: null,
        completedStartDate: null,
        completedEndDate: null,
        completedByFilter: [],
        timezone: this.currentTimezone, // Include the timezone in the filters
      };
      if (this.filters !== undefined) filters = { ...this.filters, timezone: this.currentTimezone }; // Merge existing filters with timezone
      var filterStartDate = filters.startDate ? moment(filters.startDate).format("YYYY-MM-DD") : null;
      var filterEndDate = filters.endDate ? moment(filters.endDate).format("YYYY-MM-DD") : null;
      var filterCompletedStartDate = filters.completedStartDate ? moment(filters.completedStartDate).format("YYYY-MM-DD") : null;
      var filterCompletedEndDate = filters.completedEndDate ? moment(filters.completedEndDate).format("YYYY-MM-DD") : null;
      this.$axios
        .post(url, {
          tab: this.category,
          targetUserId: this.targetEntityId,
          locationsFilter: filters.locationsFilter,
          typesFilter: filters.typesFilter,
          assignedToFilter: filters.assignedToFilter,
          startDate: filterStartDate,
          endDate: filterEndDate,
          completedStartDate: filterCompletedStartDate,
          completedEndDate: filterCompletedEndDate,
          completedByFilter: filters.completedByFilter,
          timezone: filters.timezone, // Send the timezone in the request body
        })
        .then((res) => {
          this.page.take = res.data.take;
          this.page.skip = res.data.skip;
          this.page.total = res.data.total;
          this.items = res.data.items;
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Failed to load tasks",
            message: "We had a problem retrieving the list of tasks. Please reload the page to try again.",
            error: err,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    loadBusinessUsers() {
      this.$axios.get(`/businesses/${this.businessId}/users/all`).then((res) => {
        this.businessUsers = res.data;
      });
    },
    complete(todoItemId) {
      this.isLoading = true;
      this.$axios
        .put(`/businesses/${this.businessId}/todo/${todoItemId}`, {
          status: "completed",
        })
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", {
            title: "Activity Completed",
            message: `Your activity was marked complete.`,
          });
          this.loadPage();
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Error completing activity",
            message: "Sorry, we had trouble completing this activity. The technicians have been notified. Please try again.",
            error: err,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    customDateFormatter(date) {
      if (date == null) return "";

      return moment
        .utc(date)
        .local()
        .format("MM/DD/YY");
    },
    dueDateFormatter(date) {
      if (date == null) return "";

      return moment(date).format("MM/DD/YY");
    },
    dueDateStatus(date) {
      let dateToday = new Date();
      dateToday.setHours(0, 0, 0, 0);
      if (moment(date).isSame(dateToday, "day")) return "today";
      else if (moment(date).diff(dateToday, "days") > 0) return "future";
      else return "overdue";
    },
    dueDateColor(date) {
      let dateToday = new Date();
      dateToday.setHours(0, 0, 0, 0);

      let diffDays = moment(date).diff(dateToday, "days");

      if (moment(date).isSame(dateToday, "day")) {
        return "black"; // Today
      } else if (diffDays > 0) {
        return "primary";
      } else {
        return "red"; // Past dates
      }
    },
    gotoMember(memberId) {
      window.open(`/businesses/${this.businessId}/members/${memberId}/plans`, "_blank");
    },
    modifyLocalDueDate(eventData) {
      const item = this.items.find((i) => i.todoItemId === eventData.todoItemId);
      if (item) item.dueDate = eventData.dueDate;
    },
    selectAll(e) {
      if (e.length === 0) this.selectedItems = [];
      else this.selectedItems = this.items.map((i) => i.todoItemId);
    },
    bulkDelete() {
      if (this.selectedItems.length > 0) {
        this.isDeleting = true;

        this.$axios
          .post(`/businesses/${this.businessId}/todo/bulk-delete`, { deletionIds: this.selectedItems })
          .then(() => {
            this.EventBus.$emit("GLOBAL_NOTIFY", {
              title: `${this.selectedItems.length} Activites Deleted`,
              message: `Your activities were deleted.`,
            });
            this.loadPage();
            this.selectedItems = [];
            this.$refs.todoItems.clearChecked();
          })
          .catch((err) => {
            this.EventBus.$emit("GLOBAL_ERROR", {
              title: "Error deleting activities",
              message: "Sorry, we had trouble deleting these activities. The technicians have been notified. Please reload the page and try again.",
              error: err,
            });
          })
          .finally(() => {
            this.isDeleting = false;
          });
      }
    },
    bulkAssign() {
      this.$refs.batchAssignModal.show(this.selectedItems); // Pass selected items to the modal
    },
    bulkUnassign() {
      this.$axios
        .post(`/businesses/${this.businessId}/todo/batch-unassign`, { todoItemIds: this.selectedItems })
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", {
            title: `${this.selectedItems.length} Activites Unassigned`,
            message: `Your activities were unassigned.`,
          });
          this.loadPage();
          this.selectedItems = [];
          this.$refs.todoItems.clearChecked();
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Error unassigning activities",
            message: "Sorry, we had trouble unassigning these activities. The technicians have been notified. Please reload the page and try again.",
            error: err,
          });
        });
    },
    unAssign(todoItem) {
      this.$axios
        .put(`/businesses/${this.businessId}/todo/${todoItem.todoItemId}`, {
          assignedToUserId: null,
          status: "open",
        })
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", {
            title: "Activity Unassigned",
            message: `Your activity was unassigned.`,
          });
          this.EventBus.$emit("activitiesUpdated");
        })
        .catch((err) => {
          this.errorTitle = `Error unassigning activity`;
          this.errorMessage = "Sorry, we had trouble unassigning this activity. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {});
    },
    closeBatchAssign() {
      this.headerCheckValue = false;
      this.$refs.todoItems.clearChecked(); // Clear the checkbox in the table
      this.selectedItems = []; // Clear selected items
    },
    async getRxItems() {
      try {
        const url = `/businesses/${this.businessId}/item-categories/rx-items`;
        this.$axios.get(url).then((res) => {
          this.rxItems = res.data;
        });
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Unable to retrieve Rx Items",
          message: "We were not able to retrieve your Rx Items. There may have been a connection error. Please reload the page to try again.",
          error,
        });
      }
    },
    placeOrder(todoItemId) {
      this.$router.push(`/businesses/${this.businessId}/order/${todoItemId}`);
    },
    edit(todoItem) {
      this.$refs.editTodoModal.show(todoItem);
    },
    updateOrder(todoItemId) {
      this.isLoading = true;
      this.$axios
        .put(`/businesses/${this.businessId}/order/${todoItemId}`, null)
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", {
            title: "Order Resubmitted",
            message: `Order was successfully resubmitted.`,
          });
          this.loadPage();
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Error resubmitting order",
            message: `There was an error resubmitting order . Please try again.`,
            error: err,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
